var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgSurveyWealth02(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 146,
    viewBox: "0 0 102 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M96.4641 25.1756H53.785C47.4942 25.1788 41.2734 26.4979 35.5205 29.0486C29.7676 31.5993 24.6094 35.3253 20.376 39.9884L-29 94.2788V157.016C-25.0468 157.016 -21.1369 156.19 -17.5206 154.59C-13.9042 152.99 -10.6609 150.651 -7.99831 147.723L98.7326 30.3147C99.1312 29.874 99.3937 29.3268 99.4883 28.7396C99.5828 28.1524 99.5053 27.5502 99.2652 27.0062C99.025 26.4623 98.6326 25.9998 98.1354 25.6748C97.6382 25.3499 97.0577 25.1765 96.4641 25.1756Z",
    stroke: "url(#paint0_linear_1901_2620)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3752 1.10583L-1.17383 18.8685V85.4641L13.0885 69.1554C17.5601 64.0481 20.0226 57.5228 20.0266 50.771V3.17559C20.0278 2.75497 19.9442 2.33831 19.7806 1.94996C19.617 1.5616 19.3767 1.20933 19.0737 0.913721C18.7707 0.618115 18.4111 0.385107 18.0159 0.228287C17.6207 0.0714665 17.1978 -0.00602206 16.772 0.000365032C16.3136 0.000342615 15.8608 0.0992848 15.4452 0.290241C15.0296 0.481196 14.6613 0.759548 14.366 1.10583",
    fill: "url(#paint1_linear_1901_2620)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1901_2620",
    x1: -29,
    y1: 131.284,
    x2: 68.1189,
    y2: 43.6194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25A94C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1901_2620",
    x1: -1.26106,
    y1: 85.377,
    x2: 19.3373,
    y2: -0.0548067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D4289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00B74F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSurveyWealth02);
export default __webpack_public_path__ + "static/media/bg_survey_wealth_02.5a8082bfd2371cc2bf5a121a2e6be371.svg";
export { ForwardRef as ReactComponent };